// extracted by mini-css-extract-plugin
export default {"actions-strip":"idkbyi","actionsStrip":"idkbyi","close-icon":"frKawJ","closeIcon":"frKawJ","share-icon":"br0sSn","shareIcon":"br0sSn","divider":"qNExDR"};